/**
 * Tauscht die Zufallsauswahl der Reihe "Fuer dich" gegen Shopifys
 * Empfehlungen - auf der Produktseite und in den Produktvorschauen des Menues.
 *
 * Beim Seitenaufbau steht in der Reihe eine wechselnde Auswahl aus dem
 * Sortiment; sie ist sofort da und braucht auf nichts zu warten. Dieses
 * Skript holt danach dieselbe Sektion ein zweites Mal ueber die
 * Empfehlungs-Schnittstelle (intent=related: Kaufmuster, Beschreibungen,
 * gemeinsame Kollektionen). Kommen Empfehlungen zurueck, ersetzt es die
 * Reihe; kommt nichts - etwa solange Verkaufsdaten fehlen -, bleibt alles
 * beim Alten und niemand merkt etwas.
 *
 * Dieselben Kacheln wandern anschliessend in die Menuevorschauen: die
 * Produktreihe im aufgeklappten Menue am Rechner und in der Schublade auf dem
 * Handy zeigt auf Produktseiten damit ebenfalls Passendes statt der festen
 * Kollektion. Getauscht wird dort nur der Kachelinhalt; Anzahl und Huellen
 * der Listen bleiben, damit deren Spalten- und Versteckregeln weitergelten.
 */

const wurzel = document.querySelector('dp-scroller[data-dp-empfehlungen]');

if (wurzel) {
  const adresse =
    wurzel.dataset.dpEmpfehlungen +
    '?section_id=' + encodeURIComponent(wurzel.dataset.dpAbschnitt) +
    '&product_id=' + encodeURIComponent(wurzel.dataset.dpProdukt) +
    '&limit=10&intent=related';

  fetch(adresse)
    .then((antwort) => (antwort.ok ? antwort.text() : Promise.reject(new Error('Status ' + antwort.status))))
    .then((text) => {
      const geliefert = new DOMParser().parseFromString(text, 'text/html');
      const neu = geliefert.querySelector('dp-scroller');
      const kacheln = neu ? [...neu.querySelectorAll('li.dp-sub-brand__product')] : [];

      // Ohne Empfehlungen bleibt die Zufallsauswahl stehen.
      if (!kacheln.length) return;

      /* ------------------------------------------ Reihe auf der Seite */

      wurzel.replaceWith(document.importNode(neu, true));

      /* --------------------------------------------- Vorschau im Menue */

      /*
       * Am Rechner: die Produktliste im aufgeklappten Menue. Jede Zelle
       * behaelt ihre Huelle (an ihr haengen Spalten- und Versteckklassen),
       * nur die Kachel darin wird ersetzt. Gibt es weniger Empfehlungen als
       * Zellen, behalten die uebrigen ihren bisherigen Inhalt.
       */
      for (const liste of document.querySelectorAll('.mega-menu__content-list--products')) {
        [...liste.children].forEach((zelle, stelle) => {
          const kachel = kacheln[stelle] && kacheln[stelle].querySelector('.dp-product');
          if (!kachel) return;
          zelle.replaceChildren(document.importNode(kachel, true));
        });
      }

      /*
       * Auf dem Handy: die Produktzellen der Menue-Schublade. Dort steckt in
       * jeder Zelle eine schlichte Karte ohne Schnellkauf-Feld - das Feld
       * stoert nicht, es zeigt sich nur bei einem Zeigegeraet.
       */
      const zellen = document.querySelectorAll('.menu-drawer__featured-content-list-item--product');
      zellen.forEach((zelle, stelle) => {
        const kachel = kacheln[stelle] && kacheln[stelle].querySelector('.dp-product');
        if (!kachel) return;
        zelle.replaceChildren(document.importNode(kachel, true));
      });

      // Farbpunkte, Bildwechsel und Laufschriften an den neuen Kacheln.
      document.dispatchEvent(new CustomEvent('dp:nachschub'));
    })
    .catch(() => {
      /* Dann eben die Zufallsauswahl - sie steht ja schon da. */
    });
}
